import { Box } from '@chakra-ui/react'
import React from 'react'

const Stickybox = props => <Box position={'sticky'} top={'lg'} {...props}/>

export default Stickybox
